
  export default {
  	props: ['product', 'type'],
  	data(){
  		return {
  			id: false,
  			name: false,
  			url: false,
  			image: false
  		}
  	},
  	created(){
  		console.log('yotpo', this.product)
			try {
	  		switch(this.type){
		  		case 'course':
		  			this.id = 'c' + this.product.id
		  			this.name = this.product.title
		  			this.url = 'https://truefire.com/c' + this.product.id
		  			this.image = 'https://df4emreqpcien.cloudfront.net/images/courses/' + this.product.id + '/169_820@2x.jpg?width=416&format=webp'
		  			break;
		  		case 'itj':
		  			this.id = 'j' + this.product.id
		  			this.name = this.product.title
		  			this.url = 'https://truefire.com/j' + this.product.id
		  			this.image = 'https://d2xkd1fof6iiv9.cloudfront.net/images/itjs/' + this.product.id + '/169_820.jpg'
		  			break;
	  		}
				const yotpoApi = new Yotpo.API(yotpo)
				this.$nextTick(() => {
					yotpoApi.refreshWidgets()
				})
			} catch(err) {}
  	}
  }
